import {createContext} from 'react'

const ResultContext = createContext();


export default ResultContext